<template>
    <div class="page-container">
        <!-- 头部横幅 -->
        <section class="hero">
            <div class="container">
                <h1>{{ title }}</h1>
                <p>{{ subtitle }}</p>
            </div>
        </section>

        <section class="page-content">
          <div class="tab-container">
            <!-- Tab 导航：蓝白风格 + 三端滚动适配 -->
            <div class="tab-scroll-wrap">
              <div class="tab-nav">
                <div class="tab-item" v-for="(tab, index) in tabList" :key="index" @click="activeTab = index" 
                :class="{ active: activeTab === index }">
                  {{ tab.name }}
                </div>
              </div>
            </div>

            <!-- Tab 内容：对应展示每个 tab 的 dataList 卡片列表 -->
            <div class="tab-content">
              <div v-show="activeTab === index" v-for="(tab, index) in tabList" :key="index" class="tab-panel">
                <div class="card-list">
                  <div 
                      class="card-item" 
                      v-for="(card, cardIndex) in tab.dataList" 
                      :key="cardIndex"
                  >
                    <!-- 卡片标题：居中显示，空标题隐藏多余样式 -->
                    <div class="card-title" :class="{ empty: !card.title }">
                        {{ card.title }}
                        <div class="card-title-industry">{{ card.number }}</div>
                    </div>
                    <div v-if="index === 0">
                      <!-- 峰会论坛内容 -->
                      <img :src="card.imgUrl" alt="Card Image" class="card-img-500" />
                      <div class="card-desc" v-if="card.content">{{ card.content }}</div>
                    </div>
                    <div v-else-if="index === 1">
                      <!-- 3 张图片并排：等宽布局，适配三端 -->
                      <div class="card-img-group">
                          <img
                              v-for="(pic, picIndex) in card.picList"
                              :key="picIndex"
                              :src="pic"
                              alt="Card Content Image"
                              class="card-img"
                              loading="lazy" 
                          />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <Back></Back>
    </div>
</template>
  
<script>
import Back from '../components/Back.vue';

export default {
    name: "Forum",
    components: {
        Back
    },
    data() {
        return {
            title: 'International Events',
            subtitle: 'Go Global, Touch the World',
            activeTab: 0, // 当前激活的 Tab 索引
            tabList: [
              {
                index: 0,
                name: "Shenzhen Outbound Summit",
                content: "...",
                dataList: [
                  {
                      number: "1st Shenzhen Outbound Summit",
                      title: "2016 Shenzhen Outbound Summit ",
                      imgUrl: "https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/2016.jpg", // 替换为你的图片路径
                      content: `On April 8, 2016, the 2016 Shenzhen Outbound Summit was held at Wu Zhou Guest House. Hosted by the Shenzhen Municipal Bureau of Commerce, Industry and Information Technology and organized by the Shenzhen Outbound Alliance, the event was attended by distinguished guests and leaders including Mr Chen Biao, then Vice Mayor , who witnessed the inauguration of SOA and the signing ceremony with 12 institutions. SOA is committed to building a comprehensive service platform to provide multi-faceted support for Shenzhen-based enterprises. The forum consisted of an international exchange seminar and an expert roundtable forum. Wang Chuanfu, Chairman of BYD, and other industry leaders shared their valuable experience, while financial experts offered strategic advice for enterprises' internationalization.The event attracted 380 delegates from more than 20 countries and regions and was highly recognized by all participants.`
                  },
                  {
                      number: "2nd Shenzhen Outbound Summit",
                      title: "2017 Shenzhen International Production Capacity Cooperation Conference",
                      imgUrl: "https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/2017.jpg", // 替换为你的图片路径
                      content: `On May 26, 2017,2017 Shenzhen International Production Capacity Cooperation Conference was held at Wu Zhou Guest House, co-hosted by the Shenzhen Municipal Bureau of Commerce, Industry and Information Technology and the Shenzhen Outbound Alliance; the seminar focused on themes such as industrial advantages and talent highlands, and included sessions such as address, keynote and roundtable dialogues; SOA has achieved fruitful results in its first anniversary, the "SOA Africa Chapter" was established on site, and a number of strategic cooperation agreements were signed; the event attracted nearly 400 participants, providing strong support for Shenzhen's participation in the construction of the "Belt and Road Initiative" and boosting local enterprises' outbound expansion.`
                  },
                  {
                      number: "3rd Shenzhen Outbound Summit",
                      title: "2018 Shenzhen Outbound Summit & Innovation Conference on BRI and the GBA",
                      imgUrl: "https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/2018.jpg", // 替换为你的图片路径
                      content: `On May 29, 2018, the 2018 Shenzhen Outbound Summit & Innovation Conference on BRI and the GBA was held at Wu Zhou Guest House, hosted by the Shenzhen Outbound Alliance; the conference focused on relevant strategic themes and included sessions such as addresses, awards presentation, signing ceremonies, speeches and roundtable forums; SOA signed agreements with multiple institutions, professional and social organizations from various countries and shared experience in various aspects of development; enterprises such as BGI shared their practices, guests discussed the paths for enterprises to "go global", and the conference received support and attention from various parties, helping enterprises expand overseas markets.`
                  },
                  {
                      number: "4th Shenzhen Outbound Summit",
                      title: "2019 The 4th Shenzhen Outbound Summit & Smart Manufacturing Leadership: Regional Collaborative Innovation & Development Conference",
                      imgUrl: "https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/2019.jpg", // 替换为你的图片路径
                      content: `On May 28, 2019 The 4th Shenzhen Outbound Summit & Smart Manufacturing Leadership: Regional Collaborative Innovation & Development Conference was held at Wu Zhou Guest House, hosted by Shenzhen Outound Alliance; the conference was carried out around relevant themes, and many leaders delivered speeches to support enterprises' internationalization; the launching ceremony of the Roadlink GLB APP and Business School was held on site, the Executive President of SOA shared the service achievements and future directions of SOA's third anniversary, and enterprise representatives shared their experience and participated in roadshows; guests discussed topics such as regional collaboration serving the "Belt and Road Initiative", the conference set up exhibition booths and matchmaking exchange sessions, and gained support from various parties.`
                  },
                  {
                      number: "5th Shenzhen Outbound Summit",
                      title: "2020 The 5th Shenzhen Outbound Summit & Greater Bay Area Dual Circulation Innovation & Development",
                      imgUrl: "https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/2020.jpg", // 替换为你的图片路径
                      content: `On December 10, 2020, The 5th Shenzhen Outbound Summit & Greater Bay Area Dual Circulation Innovation & Development was held at the Grand Hyatt Shenzhen, hosted by the Shenzhen Outbound Alliance; the conference was carried out around relevant themes, and many leaders delivered speeches to introduce the achievements of Shenzhen's overseas investment; the launching ceremony of the comprehensive service platform, group standards and entrepreneur selection activity was held on site, the President of SOA shared the service achievements and future directions, and enterprise representatives gave speeches; the conference awarded plaques to more than 40 council members, gained support from various parties and helped enterprises achieve high-quality internationalization.`
                  }
                ]
              },

              {
                index: 1,
                name: "International Activities",
                content: "...",
                dataList: [
                  {
                      title: 'Munich-Shenzhen Exchange Meeting',
                      picList: [
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/shenzhen_monihei_1.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/shenzhen_monihei_2.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/shenzhen_monihei_3.jpg'
                      ]
                  },
                  {
                      title: 'London-Shenzhen Economic and Trade Cooperation Exchange Meeting',
                      picList: [
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/lundun_shenzhen_1.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/lundun_shenzhen_2.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/lundun_shenzhen_3.jpg'
                      ]
                  },
                  {
                      title: 'Dubai Airport Free Zone China Exchange Meeting',
                      picList: [
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/dibai_1.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/dibai_2.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/dibai_3.jpg'
                      ]
                  },
                  {
                      title: 'Australia Green Economy Exchange Forum',
                      picList: [
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/aodaliya_1.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/aodaliya_2.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/aodaliya_3.jpg'
                      ]
                  },
                  {
                      title: 'Baoan International Innovation and Development Summit Forum on Science and Technology Industry',
                      picList: [
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/baoan_1.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/baoan_2.jpg',
                          'https://res.roadlinkglb.com/pic/os/cases/gaofengluntan/baoan_3.jpg'
                      ]
                  }
                ]
              }
            ],
        };
    }
};
</script>

<style scoped>

.card-title-industry {
  font-size: 18px;
  color: #1890ff;
  font-weight: bold;
  text-align: center; /* 标题居中 */
  margin-top: 10px;
}

.card-img-500 {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-radius: 8px;
}

@media (max-width: 767px) {
  .card-img-500 {
      height: 300px;
  }
}
</style>